
import axios from "axios";

// ─── Axios instance ───────────────────────────────────────────
// REACT_APP_BACKEND_URL=http://localhost:3001 in your .env
const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/customer`,
});

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};
// ─── Error helper ─────────────────────────────────────────────
// Throws an Error so React Query catches it as a failed query/mutation.
const throwError = (err) => {
  const message =
    err.response?.data?.message ||
    err.message ||
    "Something went wrong.";
  throw new Error(message);
};

// ═══════════════════════════════════════════════════════════════
// 1. getAllCases

export const getAllCases = async () => {
  try {
    const res = await api.get("/cases",{
      headers: getAuthHeaders(),
    });
    return res.data.data; // the array of cases
  } catch (err) {
    throwError(err);
  }
};

// ═══════════════════════════════════════════════════════════════
// 2. getCaseById

export const getCaseById = async (caseId) => {
  try {
    const res = await api.get(`/cases/${caseId}`);
    return {
      details: {
        ...res.data.case,
        ...res.data.details,
      },
      documents: res.data.documents,
    };
  } catch (err) {
    throwError(err);
  }
};

// ═══════════════════════════════════════════════════════════════
// 3. getCaseStatus

export const getCaseStatus = async (caseId) => {
  try {
    const res = await api.get(`/cases/${caseId}/status`);
    return res.data; // { success, data: { stage, currentStatus, ... } }
  } catch (err) {
    throwError(err);
  }
};

// ═══════════════════════════════════════════════════════════════
// 4. submitCaseDetails

export const submitCaseDetails = async ({ caseId, details }) => {
  console.log("caseId:***********", caseId);
  try {
    const res = await api.post(`/cases/${caseId}/details`, details,{
      headers: getAuthHeaders(),
    });
    return res.data; 
  } catch (err) {
    throwError(err);
  }
};

// ═══════════════════════════════════════════════════════════════
// 6. submitSignedClaimForm
//    Uploads the customer-signed claim form PDF.
//    Route: POST /api/admin/cases/:caseId/claim-form  (type=SIGNED)

export const submitSignedClaimForm = async ({ caseId, file }) => {
  const formData = new FormData();
  formData.append("type", "SIGNED");
  formData.append("signedPdf", file);

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/admin/cases/${caseId}/claim-form`,
      formData,
      { headers: getAuthHeaders() }
    );
    return res.data;
  } catch (err) {
    throwError(err);
  }
};

export const uploadDocument = async ({ caseId, documentType, file }) => {
  console.log("Uploading document for caseId:", caseId, "documentType:", documentType, "file:", file);
  const formData = new FormData();
  formData.append("file", file);
  formData.append("documentType", documentType);

  try {
    const res = await api.post(`/cases/${caseId}/documents`, formData, {
       headers: getAuthHeaders(),
    });
    return res.data; // { success, message }
  } catch (err) {
    throwError(err);
  }
};

export const saveOnSpotService = async ({ caseId, onSpotService }) => {
  const res = await axios.patch(`${process.env.REACT_APP_BACKEND_URL}/api/customer/cases/${caseId}/on-spot-service`, { onSpotService });
  return res.data;
};

// export const getSurveyorDetail = async (caseId) => {
//   const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/customer/cases/${caseId}/surveyor`);
//   return res.data.data; // returns the array of surveyor rows
// };

export const getDocuments = async (caseId) => {
  const res = await api.get(`/cases/${caseId}/documents`, {
    headers: getAuthHeaders(),
  });
  return res.data?.data || [];
};

// ═══════════════════════════════════════════════════════════════
// Global case search (public route)
// GET /api/case/search?accidentCaseNo=XXX
// Returns: { success, data: { case, details, documents, timeline } }
export const getCaseByAccidentNo = async (accidentCaseNo) => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/case/search`, {
      params: { accidentCaseNo },
    });

    if (res.data?.success) return res.data.data;
    throw new Error(res.data?.message || "Case not found");
  } catch (err) {
    throwError(err);
  }
};

export const getSurveyorDetail = async (caseId) => {
  const res = await api.get(`/cases/${caseId}/surveyor`,{
    headers: getAuthHeaders(),
  });
  console.log("Surveyor details response:", res);
  return res.data?.data || [];  // returns the array of surveyor rows
};

export const getWorkshopDetail = async (caseId) => {
  const res = await api.get(`/cases/${caseId}/workshop`, {
    headers: getAuthHeaders(),
  });
  return res.data?.data || null;
};

export const getDismantleDetail = async (caseId) => {
  const res = await api.get(`/cases/${caseId}/dismantle`, {
    headers: getAuthHeaders(),
  });
  return res.data?.data || null;
};